import * as types from './action-types';

export const toggleClick = clickState => ({ type: types.TOGGLECLICK, clickState });
export const setActiveTab = activeTab => ({ type: types.SETACTIVETAB, activeTab });
export const setLoading = loadingState => ({ type: types.SETLOADING, loadingState });

